import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'ngx-webstorage';
import { EditOrderSaveChangesComponent } from '../../modules/orders/edit/save-changes/save-changes.component';
var footerComponent = /** @class */ (function () {
    function footerComponent(modalService, localSt) {
        this.modalService = modalService;
        this.localSt = localSt;
        this.hostClass = false;
        this.currentYear = new Date().getFullYear();
        this.hostClass = true;
    }
    footerComponent.prototype.ngOnInit = function () {
    };
    footerComponent.prototype.termsClick = function () {
        var _this = this;
        if (this.localSt.retrieve('orderEditingMore')) {
            this.modalService.open(EditOrderSaveChangesComponent, { backdrop: 'static', keyboard: false }).result.then(function (response) {
                if (response) {
                    _this.localSt.clear('editOrderItems');
                    _this.localSt.clear('orderEditingMore');
                    _this.localSt.clear('editOrderAddress');
                    window.open('http://zenclassics.com/terms', '_self');
                }
            });
        }
        else {
            window.open('http://zenclassics.com/terms', '_self');
        }
    };
    footerComponent.prototype.privacyClick = function () {
        var _this = this;
        if (this.localSt.retrieve('orderEditingMore')) {
            this.modalService.open(EditOrderSaveChangesComponent, { backdrop: 'static', keyboard: false }).result.then(function (response) {
                if (response) {
                    _this.localSt.clear('editOrderItems');
                    _this.localSt.clear('orderEditingMore');
                    _this.localSt.clear('editOrderAddress');
                    window.open('http://zenclassics.com/privacy-policy', '_self');
                }
            });
        }
        else {
            window.open('http://zenclassics.com/privacy-policy', '_self');
        }
    };
    return footerComponent;
}());
export { footerComponent };



// WEBPACK FOOTER //
// ./src/app/template/footer/footer.component.ts.pre-build-optimizer.js